import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Divider,
  Paper,
  Grid,
  SwipeableDrawer,
  Typography,
  TextField,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import { styled } from "@mui/material/styles";
import api from "../../../utils/Url";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#00009C",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Row({ row, index }: { row: any; index: number }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <React.Fragment>
      <StyledTableRow sx={{ border: "1px gray solid", padding: "5px" }}>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {index + 1}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }}>
          {row.fileName}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.fileNo}
        </TableCell>
        {/* <TableCell style={{ border: "1px gray solid" }}  align="center">
            {row.synopsis}
          </TableCell> */}
        <TableCell style={{ border: "1px gray solid" }} >
          {row.chackNo}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.rfid}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.status}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.remark}
        </TableCell>
      </StyledTableRow>
    </React.Fragment>
  );
}

export default function FileDetailsReports() {
  const { t } = useTranslation();



  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [data, setData] = useState<any>([]);

  const [optionFileCategory, setOptionFileCategory] = useState([
    { value: "-1", label: t("text.SelectFileCategory") },
  ]);
  const [optionFileGroup, setOptionFileGroup] = useState([
    { value: "-1", label:  t("text.SelectFileGroup") },
  ]);
  const [optionFileClass, setOptionFileClass] = useState([
    { value: "-1", label:  t("text.SelectFileClass") },
  ]);
  const [optionFilesubject, setOptionFilesubject] = useState([
    { value: "-1", label:  t("text.SelectFileSubject") },
  ]);
  const [optionFileType, setOptionFileType] = useState([
    { value: "-1", label:  t("text.SelectFileType") },
  ]);
  const [optionFileDetailsAll, setOptionFileDetailsAll] = useState([
    { value: "-1", label: t("text.SelectFile") },
  ]);
  const [optionChakNo, setOptionChakNo] = useState([
    { label: t("text.SelectChack") },
  ]);

 

  useEffect(() => {
    getFileCategoryData();
    getFileGroupData();
    getFileClassData();
    getFileSubjectData();
    getFileTypeData();
    getFileDtailsAllData();
    getChakData();
  }, []);

  const getChakData = () => {

    api
      .post( "FileDetail/GetGroupWiseCheckNo")
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["chackNo"]
          });
        }
        setOptionChakNo(arr);
      });
  };

  const getFileCategoryData = () => {
    const collectData = {
      fileCatid: -1,
    };

    api
      .post("FileCategory/GetFileCategory", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["fileCatDesc"],
            value: res.data.data[index]["fileCatid"],
          });
        }
        setOptionFileCategory(arr);
      });
  };

  const getFileGroupData = () => {
    const collectData = {
      fileGroupid: -1,
    };

    api
      .post( "FileGroup/GetFileGroup", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["fileGroupName"],
            value: res.data.data[index]["fileGroupid"],
          });
        }
        setOptionFileGroup(arr);
      });
  };

  const getFileClassData = () => {
    const collectData = {
      fileClassid: -1,
    };

    api
      .post( "FileClass/GetFileClass", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["classDescription"],
            value: res.data.data[index]["fileClassid"],
          });
        }
        setOptionFileClass(arr);
      });
  };

  const getFileSubjectData = () => {
    const collectData = {
      id: -1,
    };

    api
      .post( "FileSubject/GetFileSubject", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["fileSubjectName"],
            value: res.data.data[index]["id"],
          });
        }
        setOptionFilesubject(arr);
      });
  };

  const getFileTypeData = () => {
    const collectData = {
      fileTypeId: -1,
    };

    api
      .post( "FileType/GetFileType", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["fileTypeName"],
            value: res.data.data[index]["fileTypeId"],
          });
        }
        setOptionFileType(arr);
      });
  };

  const getFileDtailsAllData = () => {
    const collectData = {
      fileID: -1,
      fileType: -1,
      fileGroup: -1,
      fileCategory: -1,
      fileClass: -1,
      fileSubject: -1,
    };

    api
      .post( "FileDetail/GetFileDetails", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["fileName"],
            value: res.data.data[index]["fileID"],
          });
        }
        setOptionFileDetailsAll(arr);
      });
  };

  const handleFilterButtonClick = () => {
    setFilterDrawerOpen(true);
    console.log("value handleFilterButtonClick", filterDrawerOpen);
  };

  const handleCloseDrawer = () => {
    setFilterDrawerOpen(false);
  };

  interface FormValues {
    fileID: any;
    fileType: any;
    chackNo:string;
    fileGroup: any;
    fileCategory: any;
    fileClass: any;
    fileSubject: any;
  }

  const initialValues: FormValues = {
    fileID: "",
    fileType: "",
    chackNo:"",
    fileGroup: "",
    fileCategory: "",
    fileClass: "",
    fileSubject: "",
  };

  const formik = useFormik({
    initialValues: initialValues,

    onSubmit: async (values) => {
      console.log("Form values:", formik.values);

      if (values.fileID === initialValues.fileID) {
        values.fileID = -1;
      }
      if (values.fileType === initialValues.fileType) {
        values.fileType = -1;
      }
      if (values.fileGroup === initialValues.fileGroup) {
        values.fileGroup = -1;
      }
      if (values.fileCategory === initialValues.fileCategory) {
        values.fileCategory = -1;
      }
      if (values.fileClass === initialValues.fileClass) {
        values.fileClass = -1;
      }
      if (values.fileSubject === initialValues.fileSubject) {
        values.fileSubject = -1;
      }
      if (values.chackNo === initialValues.chackNo) {
        values.chackNo = "";
      }
     

      console.log("check data before submitting", values);

      const response = await api.post(
         `FileDetail/GetFileDetails`,
        values
      );
      setData(response.data.data);
      handleCloseDrawer();
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const handlePrint = () => {
    const contentElement = document.getElementById("tabcont");
    if (contentElement) {
      const clonedContent = contentElement.cloneNode(true) as HTMLElement;

      const filterButton = clonedContent.querySelector(".filter-button");
      if (filterButton) {
        filterButton.remove();
      }
      const printButton = clonedContent.querySelector(".print-button");
      if (printButton) {
        printButton.remove();
      }

      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.body.appendChild(clonedContent);

        printWindow.print();
      } else {
        console.error("Error: Unable to open print window.");
      }
    }
  };

  return (
    <Card
      style={{
        width: "100%",
        backgroundColor: "#E9FDEE",
        border: ".5px solid #fff ",
        marginTop: "3vh",
      }}
    >
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          "& .MuiDataGrid-colCell": {
            backgroundColor: "#f0ad4e",
            color: "#000",
            fontSize: 17,
            fontWeight: 900,
          },
        }}
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.FileDetailsReport")}
          </Typography>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 20,
            }}
          >
            <Button
              type="button"
              onClick={() => handleFilterButtonClick()}
              style={{
                backgroundColor: "blue",
                fontSize: "15px",
                color: "#fff",
                textTransform: "none",
                cursor: "pointer",
              }}
            >
              <FilterAltIcon />
              {t("text.Filter")}
            </Button>
            <Button
              type="button"
              onClick={handlePrint}
              style={{
                backgroundColor: "blue",
                fontSize: "15px",
                color: "#fff",
                textTransform: "none",
                cursor: "pointer",
              }}
            >
              <PrintIcon />
              {t("text.Print")}
            </Button>
            <iframe
              id="ifmcontentstoprint"
              style={{ height: "0px", width: "0px", position: "absolute" }}
            ></iframe>
          </div>
          <SwipeableDrawer
            anchor="right"
            open={filterDrawerOpen}
            onClose={handleCloseDrawer}
            onOpen={() => {}}
            slotProps={{
              backdrop: {
                style: { backgroundColor: "rgba(0, 0, 0, 0.7)" },
              },
            }}
            PaperProps={{
              style: {
                width: 310,
                boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.2)",
              },
            }}
            style={{
              zIndex: 1300,
            }}
          >
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{
                margin: "20px 0px",
              }}
              align="center"
            >
              {t("text.FileDetailsReport")}
            </Typography>
            <Divider />

            <div style={{ margin: "20px 0px" }}>
              <form onSubmit={formik.handleSubmit}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    marginLeft: "0px",
                  }}
                >
                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionFileDetailsAll}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("fileID", newValue?.value );
                        formik.setFieldTouched("fileID", true);
                        formik.setFieldTouched("fileID", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectFile")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionChakNo}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.label);

                        formik.setFieldValue("chackNo", newValue?.label );
                        formik.setFieldTouched("chackNo", true);
                        formik.setFieldTouched("chackNo", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectChack")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionFileType}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);
                        formik.setFieldValue("fileType", newValue?.value);
                        formik.setFieldTouched("fileType", true);
                        formik.setFieldTouched("fileType", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectFileType")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionFileGroup}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("fileGroup", newValue?.value);
                        formik.setFieldTouched("fileGroup", true);
                        formik.setFieldTouched("fileGroup", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectFileGroup")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionFileCategory}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("fileCategory", newValue?.value);
                        formik.setFieldTouched("fileCategory", true);
                        formik.setFieldTouched("fileCategory", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectFileCategory")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionFileClass}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("fileClass", newValue?.value);
                        formik.setFieldTouched("fileClass", true);
                        formik.setFieldTouched("fileClass", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectFileClass")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionFilesubject}
                      defaultValue={null}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("fileSubject", newValue?.value);
                        formik.setFieldTouched("fileSubject", true);
                        formik.setFieldTouched("fileSubject", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectFileSubject")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={10} item>
                    <div style={{ justifyContent: "space-between", flex: 1 }}>
                      <Button
                        type="submit"
                        variant="contained"
                        style={{
                          width: "37%",
                          // backgroundColor: "#059669",
                          margin: "0.5%",
                        }}
                      >
                        {t("text.search")}
                      </Button>
                      <Button
                        type="reset"
                        variant="contained"
                        style={{
                          width: "37%",
                          // backgroundColor: "#F43F5E",
                          margin: "0.5%",
                        }}
                        onClick={() => {
                          formik.resetForm();

                          setOptionFileClass([
                            { value: "-1", label: t("text.SelectFileClass") },
                          ]);
                        }}
                      >
                        {t("text.Clear")}
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </div>
          </SwipeableDrawer>
        </div>

        <Divider />
        <br />

        <TableContainer
          component={Paper}
          id="tabcont"
          sx={{
            maxHeight: "65vh",
            marginBottom: "10px",
            border: "1px solid #fff",
          }}
        >
          <Table
            aria-label="customized  table"
            style={{
              border: "1px gray solid",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <TableHead
              style={{
                border: "1px gray solid",
                borderCollapse: "collapse",
                position: "sticky",
                top: 0, 
                zIndex: 1, 
                backgroundColor: "#fff",
              }}
            >
              <StyledTableCell
                colSpan={10}
                align="center"
                style={{
                  fontSize: 17,
                  fontWeight: 600,
                  border: "1px gray solid",
                  padding: "5px",
                  backgroundColor: "transparent",
                  color: "#000",
                }}
              >
                {t("text.FileDetailsReport")}
              </StyledTableCell>
              <TableRow>
                {/* <StyledTableCell /> */}
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.SrNo")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.FileName")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.FileNo")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.ChackNo")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.RFID")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.Status")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.Remark")}
                </StyledTableCell>
              </TableRow>
            </TableHead>
           {data && <TableBody>
              {data.map((row: any, index: any) => (
                <Row key={row.any} row={row} index={index} />
              ))}
            </TableBody>}
          </Table>
        </TableContainer>
      </Paper>
    </Card>
  );
}
